var _rect, _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 16,
    rx: 2,
    fill: "#049B5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3456 12V4.152H18.7376V10.824H22.0016V12H17.3456ZM23.369 12V4.152H24.761V12H23.369ZM28.1598 12L25.7118 4.152H27.1878L28.2918 8.1C28.4198 8.54 28.5358 8.964 28.6398 9.372C28.7438 9.78 28.8598 10.208 28.9878 10.656H29.0358C29.1718 10.208 29.2878 9.78 29.3838 9.372C29.4878 8.964 29.5998 8.54 29.7198 8.1L30.8118 4.152H32.2398L29.8038 12H28.1598ZM33.1894 12V4.152H37.9174V5.328H34.5814V7.332H37.4014V8.508H34.5814V10.824H38.0374V12H33.1894Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.f7dbd00681e03e227ff8b401f370d9ce.svg";
export { ForwardRef as ReactComponent };